import UcRentalFormContracts from './UcRentalFormContracts.yaml?component';

export { UcRentalFormContracts };
